import { useQuery } from '@tanstack/react-query';

import { LedgerType } from '../types';
import { categoryApi } from '../api/categoryApi';

export const useGetCategories = (ledgerType: LedgerType | null) => {
  return useQuery({
    queryKey: ['categories', ledgerType] as const,
    queryFn: () => categoryApi.getCategories(ledgerType),
    enabled: !!ledgerType,
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};
